import { render } from "./FormSuggestions.vue?vue&type=template&id=38f82b1c&scoped=true"
import script from "./FormSuggestions.js?vue&type=script&lang=js"
export * from "./FormSuggestions.js?vue&type=script&lang=js"

import "./FormSuggestions.vue?vue&type=style&index=0&id=38f82b1c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f82b1c"]])

export default __exports__